module.exports = __webpack_public_path__ + "static/media/Data_insight_3-3.9dd859c6.svg";